import React, { useState } from "react";
import "../designcss/Quickerresponse.css";

import Sales from "../../../../images/LandingPageImage/sales.webp";
import Marketing from "../../../../images/LandingPageImage/sales_1x.webp";
import Support from "../../../../images/LandingPageImage/support_1x.webp";

const data = [
  {
    id: 1,
    title: "Marketing",
    boldText:
      "Reach the right customers at the right moment with smart WhatsApp campaigns.",
    desc:
      "Our tools help brands increase visibility, capture attention, and drive action through timely and targeted messaging without wasting effort or resources.",
    image: Marketing,
  },
  {
    id: 2,
    title: "Sales",
    boldText:
      "Deliver faster and smarter customer support using WhatsApp automation.",
    desc:
      "Automated replies and chatbot-driven conversations help resolve queries quickly, manage conversations smoothly, and keep customers informed and satisfied at all times.",
    image: Sales,
  },
  {
    id: 3,
    title: "Support",
    boldText:
      "Move conversations from email to instant WhatsApp communication.",
    desc:
      "Engage customers in real time, automate follow-ups, and create a smooth buying journey that builds trust and speeds up conversions.",
    image: Support,
  },
];

const QuickerResponse = () => {
  const [active, setActive] = useState(data[0]);

  return (
    <div className="qr-wrapper">
      <div className="qr-heading">
        <h3>
          Power Your Business
          <span className="qr-highlight"> Growth with WoSender</span>
        </h3>
        <p className="qr-para">
            Send Faster Automate Better Engage Smarter Convert More
        </p>
      </div>

      <div className="qr-content">
        <div className="qr-card-section">
          {data.map((item) => (
            <div
              key={item.id}
              className={`qr-card ${active.id === item.id ? "active" : ""}`}
              onClick={() => setActive(item)}
            >
              <h4>{item.title}</h4>
              <p className="qr-card-bold">{item.boldText}</p>
              <p className="qr-card-desc">{item.desc}</p>

              <div className="qr-mobile-image">
                <img src={item.image} alt={item.title} />
              </div>
            </div>
          ))}
        </div>

        <div className="qr-image-section">
          <img src={active.image} alt={active.title} />
        </div>
      </div>
    </div>
  );
};

export default QuickerResponse;
